import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Layout } from "antd";
import { MenuOutlined, MenuFoldOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import OutsideClickHandler from "react-outside-click-handler";
import Cookies from "universal-cookie";

// Type assertion to fix React 18 compatibility
const OutsideClickHandlerFixed = OutsideClickHandler as any;

const { Header } = Layout;
const cookies = new Cookies();

function MainHeader({ setCollapsed, isMobile }: any) {
  const [isOpen, setIsOpen] = useState(false);
  const userData = useSelector((state: any) => state.authentication.userData);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear cookies
    cookies.remove('token', { path: '/' });
    cookies.remove('userData', { path: '/' });

    // Clear Redux state
    dispatch({ type: "LOG_OUT" });

    // Clear localStorage (redux-persist)
    localStorage.removeItem('persist:root');

    // Clear any other potential storage
    sessionStorage.clear();

    // Navigate to login
    navigate('/login', { replace: true });
  };

  return (
    <Header style={{ padding: 0, height: 70 }}>
      <div className="navbar-header">
        <div className="d-flex">
          <button
            type="button"
            className="btn btn-sm px-3 font-size-24 header-item waves-effect"
            id="vertical-menu-btn"
            onClick={() => setCollapsed()}
          >
            {isMobile ? (
              <MenuOutlined style={{ color: "#e9ecef", fontSize: "20px" }} />
            ) : (
              <MenuFoldOutlined style={{ color: "#e9ecef", fontSize: "20px" }} />
            )}
          </button>
        </div>

        <div className="d-flex align-items-center justify-content-center">
          <div className="dropdown d-inline-block">
            <OutsideClickHandlerFixed
              onOutsideClick={() => (isOpen ? setIsOpen(false) : null)}
            >
              <button
                type="button"
                className="btn header-item waves-effect"
                onClick={() => setIsOpen(!isOpen)}
              >
                <span
                  className="d-none d-sm-inline-block ml-1"
                  style={{ color: "#fff" }}
                >
                  {userData ? (userData.last_name || userData.lastName || "") + " " + (userData.first_name || userData.firstName || "") : ""}
                </span>
                <i className="mdi mdi-chevron-down d-none d-sm-inline-block"></i>
              </button>
            </OutsideClickHandlerFixed>
            <div
              className={`dropdown-menu dropdown-menu-right ${
                isOpen ? "show" : ""
              }`}
            >
              {/* <Link className="dropdown-item" to="/profile">
                <i className="mdi mdi-face-profile font-size-16 align-middle mr-1"></i>
                Профайл
              </Link> */}
              <div className="dropdown-divider"></div>
              <button
                className="dropdown-item"
                onClick={handleLogout}
                style={{ cursor: 'pointer', border: 'none', background: 'none', textAlign: 'left', width: '100%' }}
              >
                <i className="mdi mdi-logout font-size-16 align-middle mr-1"></i>
                Гарах
              </button>
            </div>
          </div>
        </div>
      </div>
    </Header>
  );
}

export default MainHeader;
